import React from "react";
import { motion } from "framer-motion";

const variants = {
	up: { y: 28, opacity: 0 },
	down: { y: -22, opacity: 0 },
	left: { x: 32, opacity: 0 },
	right: { x: -32, opacity: 0 },
	fade: { opacity: 0 },
	blur: { opacity: 0, y: 16, filter: "blur(10px)" },
};

/** 뷰포트 진입 시 한 번만 재생되는 등장 애니메이션 */
export default function Reveal({ children, from = "up", delay = 0, duration = 0.75, className, once = true }) {
	return (
		<motion.div
			className={className}
			initial={variants[from]}
			whileInView={{ x: 0, y: 0, opacity: 1, filter: "blur(0px)" }}
			viewport={{ once, margin: "-12% 0px -12% 0px" }}
			transition={{ duration, delay, ease: [0.22, 1, 0.36, 1] }}
		>
			{children}
		</motion.div>
	);
}

/**
 * 글자를 한 자씩 쌓아 올리는 디스플레이 타이틀.
 *
 * 뷰포트 트리거는 반드시 바깥 컨테이너에 걸어야 한다. 각 글자는
 * overflow-hidden 안에서 아래로 밀려나 있는데, IntersectionObserver 는
 * 조상의 클리핑까지 계산하기 때문에 글자 자체를 관찰하면 교차율이
 * 영원히 0이라 애니메이션이 시작되지 않는다.
 */
export function RevealText({ text, className, charClassName, delay = 0, stagger = 0.028 }) {
	const words = String(text).split(" ");
	let index = -1;

	return (
		<motion.span
			className={className}
			initial="hidden"
			whileInView="visible"
			viewport={{ once: true, amount: 0.1 }}
		>
			{words.map((word, wi) => (
				<span key={`${word}-${wi}`} className="inline-block overflow-hidden align-bottom">
					{[...word].map((char, ci) => {
						index += 1;
						const charDelay = delay + index * stagger;
						return (
							<motion.span
								key={`${char}-${ci}`}
								className={`inline-block ${charClassName || ""}`}
								variants={{
									hidden: { y: "110%" },
									visible: { y: 0, transition: { duration: 0.9, delay: charDelay, ease: [0.22, 1, 0.36, 1] } },
								}}
							>
								{char}
							</motion.span>
						);
					})}
					{wi < words.length - 1 && <span className="inline-block">&nbsp;</span>}
				</span>
			))}
		</motion.span>
	);
}
